import Types from "./Types";

export const getFinancesSuccess = (payload) => ({
  type: Types.GET_FINANCES_SUCCESS,
  payload,
});

export const getFinancialStatusSuccess = (payload) => ({
  type: Types.GET_FINANCIAL_STATUS_SUCCESS,
  payload,
});

export const getStoreTransactionsSuccess = (payload) => ({
  type: Types.GET_STORE_TRANSACTIONS_SUCCESS,
  payload,
});

export const financialLoading = (payload) => ({
  type: Types.FINANCIAL_LOADING,
  payload,
});
